// 节点文本默认配置
let customText = {
  name: {
    show: true,
    fontSize: 14
  },
  value: {
    show: true,
    fontSize: 14
  },
  percent: {
    show: true,
    fontSize: 14
  }
};

function increaseBrightness(colorHex, factor) {
  // 将颜色转换为RGB
  const r = parseInt(colorHex.slice(1, 3), 16);
  const g = parseInt(colorHex.slice(3, 5), 16);
  const b = parseInt(colorHex.slice(5, 7), 16);

  // 计算新的RGB值，确保不超过255
  const newR = Math.min(255, r * factor);
  const newG = Math.min(255, g * factor);
  const newB = Math.min(255, b * factor);

  // 转换为十六进制表示形式
  const newColorHex = `#${(newR | 0).toString(16).padStart(2, '0')}${(newG | 0)
    .toString(16)
    .padStart(2, '0')}${(newB | 0).toString(16).padStart(2, '0')}`;
  return newColorHex;
}

interface Arg {
  /**
   * 文本展示字段
   */
  name: any;
  value: any;
  percent: any;
}
/**
 * 处理节点文本
 * @param sourceData 单周期源数据
 * @param handleData 单周期处理后的坐标数据
 * @param handleSiteData 单周期处理后的坐标附加数据
 * @param arg 自定义相关字段属性
 * @returns
 */

// 动态
export function handleDynamicRenderItem(handleData, handleSiteData) {
  const renderItem = function (params, api) {
    return {
      type: 'group',
      x: (params.coordSys.x + params.coordSys.width) / 2,
      y: (params.coordSys.y + params.coordSys.height) / 2,
      children: [
        {
          type: 'polygon',
          style: {
            fill:
              handleSiteData[params.dataIndex] &&
              handleSiteData[params.dataIndex].startingData?.color
                ? handleSiteData[params.dataIndex].startingData.color
                : 'none',
            stroke: '#fff',
            lineWidth: 1
          },
          shape: {
            points: handleData[params.dataIndex]
              ? handleData[params.dataIndex].slice(0, handleData[params.dataIndex].length)
              : []
          },
          emphasis: {
            style: {
              fill:
                handleSiteData[params.dataIndex] &&
                handleSiteData[params.dataIndex].startingData?.color
                  ? increaseBrightness(handleSiteData[params.dataIndex].startingData.color, 1.1)
                  : ''
            }
          }
        }
      ]
    };
  };
  return renderItem;
}

export function handleDynamicRenderItemCircle(sourceData, radius) {
  const renderItem = function (params) {
    return {
      type: 'group',
      x: (params.coordSys.x + params.coordSys.width) / 2,
      y: (params.coordSys.y + params.coordSys.height) / 2,
      children: [
        {
          type: 'circle',
          style: {
            fill: sourceData[params.dataIndex].color,
            stroke: '#fff',
            lineWidth: 1
          },
          shape: {
            cx: 0,
            cy: 0,
            r: radius
          },
          emphasis: {
            style: {
              fill: sourceData[params.dataIndex]
                ? increaseBrightness(sourceData[params.dataIndex].color, 1.1)
                : ''
            }
          }
        }
      ]
    };
  };
  return renderItem;
}

export function handleDynamicRenderItemText(handleData, handleSiteData, arg?: Arg) {
  const customTextValue = Object.assign({}, customText, arg);
  const renderItem = function (params, api) {
    // 绘图容器位置信息
    const textWidthArr = handleData[params.dataIndex]
      ? handleData[params.dataIndex]
          .slice(0, handleData[params.dataIndex].length)
          .map(item => item[0])
      : [0];
    return {
      type: 'group',
      x: (params.coordSys.x + params.coordSys.width) / 2,
      y: (params.coordSys.y + params.coordSys.height) / 2,
      children: [
        {
          type: 'circle',
          style: {},
          x: handleSiteData[params.dataIndex].interpolatedSiteX,
          y:
            customTextValue.value.show === true || customTextValue.percent.show === true
              ? handleSiteData[params.dataIndex].interpolatedSiteY - 18
              : handleSiteData[params.dataIndex].interpolatedSiteY,
          shape: {
            r: 0
          },
          textContent: {
            style: {
              text:
                handleSiteData[params.dataIndex] &&
                handleSiteData[params.dataIndex].startingData?.name
                  ? handleSiteData[params.dataIndex].startingData?.name
                  : '',
              fontSize: customTextValue.name.fontSize,
              textAlign: 'center',
              fill: '#fff',
              opacity:
                customTextValue.name.show === false ||
                (handleSiteData[params.dataIndex].startingData?.name &&
                  (handleSiteData[params.dataIndex].startingData?.name.length + 3) *
                    customTextValue.name.fontSize >
                    Math.max(...textWidthArr) - Math.min(...textWidthArr))
                  ? 0
                  : 1
            }
          },
          textConfig: {
            position: 'inside'
          }
        },
        {
          type: 'circle',
          style: {},
          x: handleSiteData[params.dataIndex].interpolatedSiteX,
          y: handleSiteData[params.dataIndex].interpolatedSiteY,
          shape: {
            r: 0
          },
          textContent: {
            style: {
              text:
                handleSiteData[params.dataIndex] &&
                handleSiteData[params.dataIndex].startingData?.bit &&
                handleSiteData[params.dataIndex].startingData?.value
                  ? handleSiteData[params.dataIndex].startingData?.value +
                    handleSiteData[params.dataIndex].startingData?.bit
                  : handleSiteData[params.dataIndex] &&
                    handleSiteData[params.dataIndex].startingData?.value
                  ? handleSiteData[params.dataIndex].startingData?.value
                  : '',
              fontSize: customTextValue.value.fontSize,
              textAlign: 'center',
              fill: '#fff',
              opacity:
                customTextValue.value.show === false ||
                (handleSiteData[params.dataIndex].startingData?.value &&
                  (handleSiteData[params.dataIndex].startingData?.value.toString().length  + 3) *
                    customTextValue.value.fontSize >
                    Math.max(...textWidthArr) - Math.min(...textWidthArr))
                  ? 0
                  : 1
            }
          },
          textConfig: {
            position: 'inside'
          }
        },
        {
          type: 'circle',
          style: {},
          x: handleSiteData[params.dataIndex].interpolatedSiteX,
          y:
            handleSiteData[params.dataIndex].interpolatedSiteY +
            (customTextValue.value.show === false ? 0 : 14),
          shape: {
            r: 0
          },
          textContent: {
            style: {
              text: handleSiteData[params.dataIndex].startingData?.percent
                ? handleSiteData[params.dataIndex].startingData?.percent
                : '',
              fontSize: customTextValue.percent.fontSize,
              textAlign: 'center',
              fill: '#fff',
              opacity:
                customTextValue.percent.show === false ||
                (handleSiteData[params.dataIndex].startingData?.percent &&
                  (handleSiteData[params.dataIndex].startingData?.percent.length + 3) *
                    customTextValue.percent.fontSize >
                    Math.max(...textWidthArr) - Math.min(...textWidthArr))
                  ? 0
                  : 1
            }
          },
          textConfig: {
            position: 'inside'
          }
        }
      ]
    };
  };
  return renderItem;
}

export function handleDynamicRenderItemCircleText(handleData, arg?: Arg) {
  const customTextValue = Object.assign({}, customText, arg);
  const renderItem = function (params) {
    return {
      type: 'group',
      x: (params.coordSys.x + params.coordSys.width) / 2,
      y: (params.coordSys.y + params.coordSys.height) / 2,
      children: [
        {
          type: 'circle',
          x: 0,
          y:
            (customTextValue.value.show === true || customTextValue.percent.show) === true
              ? -18
              : 0,
          shape: {
            r: 0
          },
          textContent: {
            style: {
              text: handleData[params.dataIndex].name,
              fontSize: customTextValue.name.fontSize,
              textAlign: 'center',
              fill: '#fff',
              opacity: customTextValue.name.show === true ? 1 : 0
            }
          },
          textConfig: {
            position: 'inside'
          }
        },
        {
          type: 'circle',
          x: 0,
          y: 0,
          shape: {
            r: 0
          },
          textContent: {
            style: {
              text: handleData[params.dataIndex].value,
              fontSize: customTextValue.value.fontSize,
              textAlign: 'center',
              fill: '#fff',
              opacity: customTextValue.value.show === true ? 1 : 0
            }
          },
          textConfig: {
            position: 'inside'
          }
        },
        {
          type: 'circle',
          x: 0,
          y: customTextValue.value.show === false ? 0 : 14,
          shape: {
            r: 0
          },
          textContent: {
            style: {
              text: handleData[params.dataIndex].percent,
              fontSize: customTextValue.percent.fontSize,
              textAlign: 'center',
              fill: '#fff',
              opacity: customTextValue.percent.show === true ? 1 : 0
            }
          },
          textConfig: {
            position: 'inside'
          }
        }
      ]
    };
  };
  return renderItem;
}
